import { useState, useEffect } from 'react';
import './App.css';
import { useForm, FormProvider } from 'react-hook-form';
import Spiner from './components/services/spiner';
import axios from 'axios';
import SetShape from './components/setShape';
import SetDiimentions from './components/setDimentions';
import SetColor from './components/setColor';
import SetChamfer from './components/setChamfer';
import Additionally from './components/additionally';
// import SendCalculation from './components/sendCalculation';
import Calculation from './components/calculation';
import logo from './img/logo-max.png';
import { TITLE, TITLE_PART1, TITLE_PART2, TITLE_PART3, TITLE_PART4, TITLE_PART5 } from './components/services/texts';

function App() {
    const methods = useForm({
        defaultValues: {
            shape: 'straight',
            dimentions: {
                length_a: '',
                length_b: '',
                length_c: '',
                length_d: '',
            },
            stone: {
                producer: 'avant',
                color: '',
            },
            chamfer: 'E',
            additional: {
                sink: false,
                montage: false,
                delivery: false,
            },
        },
    });

    const PATH_API = process.env.REACT_APP_API_URL;
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [initShape, setInitShape] = useState([]);
    const [initDimentions, setInitDimentions] = useState([]);
    const [initChamfers, setInitChamfers] = useState([]);
    const [result, setResult] = useState('');
    const [currencyUsd, setCurrencyUsd] = useState([]);

    //-----------------------------------------------------------------------------

    const { watch } = methods;
    // Отслеживаем все поля
    const allFields = watch();
    const jsonAllFeilds = JSON.stringify(allFields);
    // сбрасываем результат при изменении вводных данных
    useEffect(() => {
        setResult('');
        // console.log('Текущее состояние формы:', allFields);
    }, [jsonAllFeilds]);

    //-----------------------------------------------------------------------------

    const onSubmit = (defaultValues) => {
        axios
            .post(`${PATH_API}/calc`, defaultValues)
            .then((response) => setResult(response.data))
            .catch((err) => alert('Data does not sended to calculator. The error is:', err));
    };

    useEffect(() => {
        const initialData = async () => {
            try {
                const [initShape, initDimentions, initChamfers, currentUsdFromNbu] = await Promise.all([
                    axios.get(`${PATH_API}/initShape`),
                    axios.get(`${PATH_API}/initDimentions`),
                    axios.get(`${PATH_API}/chamfers`),
                    axios.get('https://bank.gov.ua/NBUStatService/v1/statdirectory/exchange?json'),
                ]);
                setInitShape(initShape.data);
                setInitDimentions(initDimentions.data);
                setInitChamfers(initChamfers.data);
                setCurrencyUsd(currentUsdFromNbu.data);
            } catch (error) {
                setError(error.response?.data?.message || error.message);
                console.error('Ошибка инициализации данных:', error);
            } finally {
                setLoading(false);
            }
        };
        // axios.get('http://localhost:3001/api/initShape')
        // .then((response) => setInitShape(response.data))
        // .catch((err) => alert('Error when executed AXIOS in request the initShape price. The error is:', err))
        // axios.get('http://localhost:3001/api/initDimentions')
        // .then((response) => setInitDimentions(response.data))
        // .catch((err) => alert('Error when executed AXIOS in request the initShape price. The error is:', err))

        initialData();
        // eslint-disable-next-line
    }, []);

    //get current currency for dollar
    const usdData = currencyUsd.filter((curr) => curr.r030 === 840);

    if (loading) {
        return <Spiner />;
    }

    if (error) {
        return <div>Ошибка загрузки данных: {error.message}</div>;
    }

    return (
        <FormProvider {...methods}>
            <div className="header">
                <a href="https://interkam.od.ua">
                    <img src={logo} alt="интеркам"></img>
                </a>
            </div>
            <div className="main-wrap">
                <main>
                    <article>
                        <h1>{TITLE}</h1>
                        <section>
                            <p>{TITLE_PART1}</p>
                            <br />
                            <p>{TITLE_PART2}</p>
                            <br />
                            <p>{TITLE_PART3}</p>
                            <br />
                            <p>{TITLE_PART4}</p>
                            <br />
                            <p>{TITLE_PART5}</p>
                        </section>
                    </article>
                    <form onSubmit={methods.handleSubmit(onSubmit)}>
                        <SetShape allShapes={initShape} />
                        <SetDiimentions allShapes={initShape} initDimentions={initDimentions} />
                        <SetColor />
                        <SetChamfer initChamfers={initChamfers} />
                        <Additionally />
                        <Calculation result={result} allFields={allFields} allShapes={initShape} usdData={usdData} />
                    </form>

                    {/* <SendCalculation /> */}
                </main>
            </div>
        </FormProvider>
    );
}

export default App;
